import { useMutation } from "@apollo/client";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { gql } from "generated-graphql";
import { useCallback } from "react";

import { useCurrentUser } from "./useCurrentUser";
import { useFeatureFlags } from "./useFeatureFlags";

const QUEUE_MANIFEST_DOCUMENT_PARSE = gql(`
  mutation QueueManifestDocumentParse($input: QueueManifestDocumentParseInput!) {
    queueManifestDocumentParse(input: $input) {
      documentId
      job {
        id
        status
      }
    }
  }
`);

export function useQueueManifestDocumentParse() {
  const { isStaff } = useCurrentUser();
  const { featureFlags } = useFeatureFlags();
  const [mutate, { loading }] = useMutation(QUEUE_MANIFEST_DOCUMENT_PARSE);

  const canQueueManifestParse = isStaff && !!featureFlags[FeatureFlagKey.ManifestDocumentIngest];

  const queueManifestDocumentParse = useCallback(
    async (input: {
      tenantId: string;
      documentIds: string[];
      facilityId?: string;
      manifestTrackingNumber?: string;
      generatorId?: string;
    }) => {
      const { data } = await mutate({ variables: { input } });
      return data?.queueManifestDocumentParse ?? [];
    },
    [mutate]
  );

  return { queueManifestDocumentParse, loading, canQueueManifestParse };
}
